import StyledWrapper from './style';
import { getStatusColor, getChipTextColor } from '../../../utils/utilFunctions';

const DecisionChip = ({ label }) => {
	return (
		<StyledWrapper.ButtonContainer>
			<StyledWrapper.DecisionContainer>Decision</StyledWrapper.DecisionContainer>
			<StyledWrapper.StatusContainer
				color={getChipTextColor(label)}
				backgroundColor={getStatusColor(label)}
			>
				{label}
			</StyledWrapper.StatusContainer>
		</StyledWrapper.ButtonContainer>
	);
};

export default DecisionChip;
